<template>
  <nav class="navigation-bar">
    <div class="logo">
      <img :src="navigator.logoSrc" alt="Logo" />
    </div>
    <div class="hamburger" @click="toggleMenu">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div
      class="nav-list"
      :class="{ 'mobile-nav-list': navigator.isMobileMenuOpen }"
      v-show="!navigator.isMobile || navigator.isMobileMenuOpen"
    >
      <router-link
        v-for="(item, index) in navigator.navItems"
        :key="index"
        :to="item.path"
        @click="navigator.isMobileMenuOpen = false"
      >
        {{ $t(`navigation.${item.title}`) }}
      </router-link>
      <div
        class="language"
        @click="changeLanguage($i18n.locale === 'en' ? 'zh' : 'en')"
      >
        {{ $i18n.locale === "en" ? "中文" : "ENGLISH" }}
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      navigator: {
        logoSrc: this.getLogoSrc(),
        navItems: [
          { path: "/", title: "home" },
          { path: "/about", title: "about" },
          { path: "/products", title: "products" },
          { path: "/join", title: "join" },
          { path: "/partner", title: "partner" },
        ],
        isMobileMenuOpen: false,
        isMobile: false,
      },
    };
  },
  methods: {
    toggleMenu() {
      this.navigator.isMobileMenuOpen = !this.navigator.isMobileMenuOpen;
    },
    checkScreenSize() {
      this.navigator.isMobile = window.innerWidth < 800;
      if (!this.navigator.isMobile) {
        this.navigator.isMobileMenuOpen = false;
      }
    },
    changeLanguage(lang) {
      this.$i18n.locale = lang;
      this.updateLogo();
    },
    getLogoSrc() {
      return this.$i18n.locale === "zh"
        ? require("@/assets/logo1.png")
        : require("@/assets/logo2.png");
    },
    updateLogo() {
      this.navigator.logoSrc = this.getLogoSrc();
    },
  },
  watch: {
    "$i18n.locale": function (newLocale) {
      this.updateLogo();
    },
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenSize);
  },
};
</script>

<style lang="less">
.navigation-bar {
  letter-spacing: 0.1vw;
  width: 100%;
  height: 4vw;
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: fixed;
  top: 0;
  z-index: 100;
  background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(10px);
  transition: height 0.3s ease;
}

.logo {
  width: 14vw;
  display: flex;
  justify-content: center;

  img {
    max-width: 100%;
    height: auto;
    transition: transform 0.3s ease;

    &:hover {
      transform: scale(1.05);
    }
  }
}

.nav-list {
  width: 28vw;
  display: flex;
  justify-content: space-between;
  align-items: center;

  a {
    color: rgba(0, 0, 0, 0.7);
    font-size: 0.8vw;
    padding: 0.8vw 0;
    transition: all 0.3s ease;
    position: relative;

    &:hover {
      text-decoration: none;
      color: #d01814;
    }

    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 0;
      height: 2px;
      background: #d01814;
      transition: width 0.3s ease;
    }

    &:hover::after {
      width: 100%;
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.hamburger {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 30px;
  height: 20px;
  cursor: pointer;
  z-index: 101;

  span {
    display: block;
    height: 2px;
    width: 100%;
    background-color: #000;
    transition: all 0.3s ease;
  }
}
// 手机端
@media screen and (max-width: 940px) {
  .navigation-bar {
    height: 2rem;
    margin-top: 0;
    border-bottom: .15rem solid red;
  }

  .logo {
    width: 7rem;
    
  }

  .hamburger {
    width: 0.5rem;
    height: 50%;
    display: flex;

    span {
      width: 1.0rem;
      height: 0.2rem;
      right: 0;
      margin-left: 0;
    }
  }

  .nav-list {
    display: none;
 
    &.mobile-nav-list {
 
      display: flex;
      flex-direction: column;
      position: fixed;
      top: 2rem;
      left: 0;
      width: 100%;
      background: #fff;
      backdrop-filter: blur(10px);
      padding-left: 30px;
      margin-top:0.1rem;

      a {
        width: 75%;
        padding-left:30%;
        display: block;
        padding: 12px 16px;
        font-size: 2vw;
        color: #ff6866;
        font-weight: bold;
        border-bottom: 1px solid #ddd;
        text-align: left;
        text-decoration: none;
      }
    }
  }
  .language {
    display: none;
  }
}

// 平版
@media screen and (max-width: 1024px) and (min-width: 801px) {
  .navigation-bar {
    height: 70px;
  }

  .logo {
    width: 200px;
  }
}

.language {
  border-left: 1px solid #000;
  font-size: 0.8vw;
  color: #000;
  padding-left: 0.5vw;
  cursor: pointer;
}
</style>
